export default {
    'HomePage.welcome':'欢迎您',
    'FirstPage.Home':'首页',
    'HomePage.password':'修改密码',
    'HomePage.logout':'退出',
    'HomePage.title':'备件目录',
    'HomePage.backend':'进入后台',
    'HomePage.DF': '奕派科技售后技术服务平台',
    // 'HomePage.foot':'浙江吉利控股集团有限公司 版权所有',
    'news.welcome': '您好，欢迎来到奕派科技售后技术服务平台',
    'yjNews.welcome': '您好，欢迎来到奕境备件目录系统',
    'news.popTitle': '消息通知',

    //登录表单验证
    'loginPage.usrName':'用户名',
    'loginPage.usrNameInfo':'用户名不能为空，请输入用户名！',
    'loginPage.passWord':'密码',
    'loginPage.passWordInfo':'密码不能为空，请输入密码！',
    'loginPage.code':'验证码',
    'loginPage.codeInfo':'请输入验证码',
    'loginPage.codeWrong':'验证码错误',
    'loginPage.browse':'为了更好的使用体验，请使用',
    'loginPage.login':'登录',

    //强制修改密码
    'changePassword.oldPassword':'旧密码',
    'changePassword.newPassword':'新密码',
    'changePassword.againPassword':'再次输入密码',
    'changePassword.fillPassword':'请填写密码',
    'changePassword.twicePassword':'两次输入的密码不一致',
    'forceChangePassword.title':'请更新密码',
    'forceChangePassword.sameAsTheOld':'不能与旧密码一样，请重新输入',
    'forceChangePassword.moreCharacters':'使用8个至16位字符(字母大小写、数字和符号的组合)',
    'forceChangePassword.success':'密码修改成功',
    'forceChangePassword.fail':'初始密码输入错误，请重新输入',
    'forceChangePassword.timeReminder': '您的账号还有{day}天过期，请修改密码',

    //服务站操作
    'StationModify.Define': '确定',
    //购物车单条删除
    'shopping.oneDeleteTitle':'提示',
    'shopping.msg': '请先选择数据',

    //侧边栏
    'sidebar.carInquiry':'车系查询',
    // 'sidebar.news':'新闻',
    'sidebar.order':'购物车',
    'sidebar.carModel':'备件查询',
    'sidebar.carInquiryChange':'备件变更查询',
    // 'sidebar.onlineQestion':'答疑平台',
    'sidebar.knowledgeBase':'文件夹',
    // 'sidebar.orderHistory':'订单历史',

    //按钮
    'search': '查询',
    'reset': '重置',
    'operation': '操作',
    'download': '下载',
    'warnReset': '重置成功',
    'overseas': '海外',
    'domestic': '国内',
    'all':'全部',

    //删除
    'ServiceStation.DeleteCancelText': '取消',

    //车系查询
    'carInquiry.searchInput':'VIN码',
    'carInquiry.notice': '通知',
    'carInquiry.index': '索引',
    'carInquiry.announcement': '公告',

    //新闻
    'news.tableNo':'序号',
    'news.tableTitle':'标题',
    'news.tableCategory':'所属类别',
    'news.tableAffiliation':'所属栏目',
    'news.tableSubmitTime':'发布时间',
    'news.tableFounder':'创建人',

    //知识库
    'knowledgeBase.fileName':'文件名称',
    'knowledgeBase.uploadUser':'上传人',
    'knowledgeBase.uploadTime':'上传时间',
    'knowledgeBase.chineseName':'中文名称',

    //答疑中心
    'answerSubject.add': '新增',
    'answerSubject.addTheme': '主题',
    'answerSubject.addAMG': '车系',
    'answerSubject.VIN': 'vin码',
    'answerSubject.tableQuestioner': '提问人',
    'answerSubject.tableQuestionTime': '提问时间',
    'answerSubject.tableAMG': '车系',
    'answerSubject.AuditStatus': '审核状态',
    'answerSubject.tableAdoptState': '采纳状态',
    'answerSubject.adopted': '已采纳',
    'answerSubject.unAdopted': '未采纳',
    'answerSubject.Audited': '已审核',
    'answerSubject.Unaudited': '未审核',
    'answerSubject.productionDate': '生产日期',
    'answerSubject.engineNumber': '发动机号',
    'answerSubject.transmissionNumber': '变速器号',
    'answerSubject.edit': '编辑',
    'answerSubject.enterEngine': '必须填写完整的发动机号',
    'answerSubject.enterTransmission': '必须填写完整的变速器号',

    'answerSubject.type': '问题类型',
    'answerSubject.mainGroupCode': '主组',
    'answerSubject.groupCode': '分组',
    'answerSubject.assess': '评价',
    'answerSubject.satisfied': '满意',
    'answerSubject.noSatisfied': '不满意',
    'answerSubject.setAssess': '请评价',
    'answerSubject.replyStatus': '回复状态',
    'answerSubject.reply': '回复',
    'answerSubject.noReply': '未回复',
    'answerSubject.mine': '我的',
    'answerSubject.vin': '请选择VIN码',
    'answerSubject.resultVin': 'VIN码',
    'answerSubject.inputMainGroupCode': '请输入主组号',
    'answerSubject.inputContactName': '请输入联系人',
    'answerSubject.inputContactNumber': '请输入联系电话',
    'answerSubject.newEngineNumber': '发动机钢印号',
    'answerSubject.contactName': '联系人',
    'answerSubject.emergencyLevel': '紧急程度',
    'answerSubject.serviceStation': '服务站名称',
    'answerSubject.newTransmission': '变速器钢印号',
    'answerSubject.contactNumber': '联系电话',
    'answerSubject.email': '邮箱',
    'answerSubject.TKSReply': '感谢您对本次回复作出相应评价',
    'answerSubject.inputAssess': '请输入评价原因',
    'answerSubject.emptyEdit': '编辑内容不能为空',
    'answerSubject.askQuestion': '提问原因',
    'answerSubject.isCommit':'草稿状态',
    'answerSubject.commitReply':'草稿',
    'answerSubject.commitNoReply':'提交',
    'answerSubject.handle':'操作',
    'answerSubject.update':'修改',
    'answerSubject.commit':'提交',
    'answerSubject.selfMadeDate':'生产日期',
    'answerSubject.carMaterialName':'整车描述',
    //答疑平台新增
    'answer.addVerificationTheme': '请输入主题',
    'answer.type': '请选择问题类型',
    'answer.emergencyLevel': '请选择紧急程度',
    'answer.email': '请填写邮箱',
    'answer.groupCode': '请选择分组',
    'answer.newTransmission': '请填写联系方式',
    'answer.addVerificationMsg': '不能输入空格',
    'answer.addVerificationAMG': '请选择车系',
    'answer.addVerificationAMGInput': '请选择',
    'answer.addDealer': '经销商',
    'answer.addVerificationDealer': '请输入经销商',
    'answer.addPosition': '装配位置',
    'answer.addVerificationPosition': '请选择装配位置',
    'answer.addUpload': '上传附件',
    'answer.upload': '附件',
    'answer.addSubjectContent': '请输入主题内容',
    'answer.addSuccessfully': '主题新增成功，等待审核',
    'answer.FileUploadSucceeded': '文件上传成功',
    'answer.FileUploadFailed': '文件上传失败',
    'answer.addFiles': '请添加文件',
    'answer.twoEmergent': '本月已经提起2次紧急',

    //答疑平台主题
    'answerReply.goBack': '返回',
    'answerReply.national': '国家大区',
    'answerReply.dealer': '经销商',
    'answerReply.AMG': '车系',
    'answerReply.position': '装配位置',
    'answerReply.poster': '发帖人',
    'answerReply.postTime': '发帖时间',
    'answerReply.return': '返回',
    'answerReply.Download': '下载附件',
    'answerReply.Reply': '回复',
    'answerReply.adoption': '采纳',
    'answerReply.define': '确定',
    'answerReply.cancel': '取消',
    'answerReply.content': '请输入内容...',
    'answerReply.collapseReply': '收起回复',
    'answerReply.themeAdoption': '主题已被采纳，不能再回复、采纳',
    'answerReply.replyInfo': '请先输入回复内容',
    'answerReply.replySuccess': '回复成功',
    'answerReply.addUpload': '上传附件',
    'answerReply.viewAll': '查看全部{length}条回复',
    'answerReply.release': '发布',

    //车系查询
    'ConfigureQuery.Group': '组号',
    'ConfigureQuery.SectionNo': '节号',
    'ConfigureQuery.ReferenceNo': '索引号',
    'ConfigureQuery.name': '名称',
    'ConfigureQuery.Remark': '备注',
    'ConfigureQuery.Label': '标号',
    'ConfigureQuery.SparePartNumber': '备件编号',
    'ConfigureQuery.materialCode': '物料号',
    'ConfigureQuery.SparePartName': '备件名称',
    'ConfigureQuery.VINNumber': 'VIN号',
    'ConfigureQuery.Location': '位置',
    'ConfigureQuery.Quantity': '数量',
    'ConfigureQuery.letter': '轨件标识',
    'ConfigureQuery.DateOfActivation': '启用日期',
    'ConfigureQuery.operate': '操作',
    'ConfigureQuery.seeDetails': '查看详情',
    'ConfigureQuery.AddOrder': '添加订单',
    'ConfigureQuery.imageDisplay': '图片展示',
    'ConfigureQuery.BreakpointInformation': '断点信息',
    'ConfigureQuery.ReplacementRelationship': '替换关系',
    'ConfigureQuery.ApplicableModels': '适用车型',
    'ConfigureQuery.orderNumber': '数量',
    'ShoppingModal.title': '添加',


    //备件所属车系
    'carsSpareParts.Define': '确定',
    'carsSpareParts.code': '备件分组号',

    //配置查询模块
    'ConfigureQuery.enterCode': '请输入VIN码',
    'ConfigureQuery.querying': '查询中...',
    'ConfigureQuery.noExist': '该vin码下没有数据',
    'ConfigureQuery.searchBtn': '搜索',
    'ConfigureQuery.Annual': '年款',
    'ConfigureQuery.Displacement': '排量',
    'ConfigureQuery.Configuration': '配置',
    'ConfigureQuery.color': '内饰颜色',
    'ConfigureQuery.TransmissionType': '变速器类型',
    'ConfigureQuery.DriveMode': '驱动方式',
    'ConfigureQuery.EmissionStandards': '排放标准',
    'ConfigureQuery.VINCode': 'VIN码',
    'ConfigureQuery.reset': '重置',
    'ConfigureQuery.VINDecide': '请重新输入正确的VIN码',

    // 查询结果
    'ConfigureSearch.massage': ' 请输入搜索条件',
    'ConfigureSearch.EnterName/sparePartNumber/partNumberQuery': '输入名称/备件号/零件号查询',
    'ConfigureSearchModal.title': '查询结果',
    'ConfigureSearchModal.grade': '标号',
    'ConfigureSearchModal.sparepNo': '备件编号',
    'ConfigureSearchModal.materialCode': '物料号',
    'ConfigureSearchModal.sparepName': '备件名称',
    'ConfigureSearchModal.demand': '查询',

    //备件目录属性
    'ConfigureSpareModal.DirectoryAttribute': '备件目录属性',
    'ConfigureSpareModal.SparePartName': '备件名称',
    'ConfigureSpareModal.Remarks': '备注',
    'ConfigureSpareModal.SupplierNo': '供应商编号',//供应商编号

    //备件仓储属性
    'ConfigureSpareModal.isRecommend': '是否推荐',
    'ConfigureSpareModal.Dangerous': '是否是危险品',

    //备件详情ConfigureSpareModal
    'ConfigureSpareModal.SpareDetail': '备件详情',
    'ConfigureSpareModal.SparePicture': '备件图片',

    //备件技术属性
    'ConfigureSpareModal.TechnicalAttribute': '备件技术属性',

    //左边
    'ConfigureSpareModal.SpecificationModel': '规格型号',
    'ConfigureSpareModal.volume': '体积',
    'ConfigureSpareModal.unit': '基本计量单位',
    'ConfigureSpareModal.Regulations': '法规件',
    'ConfigureSpareModal.colour': '颜色',
    'ConfigureSpareModal.LifeCycle': '生命周期(月)',
    'ConfigureSpareModal.PartSource': '备件来源',
    'ConfigureSpareModal.partStatus': '备件状态',
    'ConfigureSpareModal.supplierCode': '供应商代码',
    'ConfigureSpareModal.MaterialType': '物料类型',
    'ConfigureSpareModal.CustomsCode': '海关编码',
    'ConfigureSpareModal.CIQText': 'CIQ文本',
    'ConfigureSpareModal.ProductGroup': '产品组',
    'ConfigureSpareModal.EntryTime': '录入时间',
    'ConfigureSpareModal.InputStartStopTime': '录入起止时间',
    'ConfigureSpareModal.Manufacturer': '生产商',
    'ConfigureSpareModal.PurchasingChannels': '采购渠道',


    //右边
    'ConfigureSpareModal.Material': '材质',
    'ConfigureSpareModal.weight': '重量',
    'ConfigureSpareModal.WeightUnit': '重量单位',
    'ConfigureSpareModal.DesignLife': '设计寿命(月)',
    'ConfigureSpareModal.skillsRequirement': '技术要求',
    'ConfigureSpareModal.DataSources': '数据来源',
    'ConfigureSpareModal.SparePartType': '备件类型',
    'ConfigureSpareModal.supplier': '供应商',
    'ConfigureSpareModal.IndustryType': '行业类型',
    'ConfigureSpareModal.OldNumber': '旧物料号',
    'ConfigureSpareModal.CommodityInspectionMark': '商检标识',
    'ConfigureSpareModal.ChineseName': '报关中文品名',
    'ConfigureSpareModal.MaterialGroup': '物料组',
    'ConfigureSpareModal.EndTime': '结束时间',

    // 图片展示
    'ConfigurePhotosModal.title': '图片展示',
    //多根树表格翻译
    'TreeTable.materialCode': '物料号',
    'TreeTable.name': '零件名称',
    'TreeTable.nameEn': '零件英文名称',
    'TreeTable.amount': '数量',
    'TreeTable.isProcurement': '采购状态',

    //购物车
    'ConfigureAddModal.title': '提示',
    'ConfigureAddModal.serviceStation': '请选择服务站',
    'ConfigureAddModal.OkText': '确定',
    'ConfigureAddModal.cancelText': '取消',
    'ConfigureAddModal.message': '请至少选择一个服务站',

    // 变更记录
    'ConfigureChangeModal.title': '变更记录',
    'ConfigureChangeModal.num': '序号',
    'ConfigureChangeModal.before': '被替换件(变更前)',
    'ConfigureChangeModal.bysparepCodes': '备件编号',
    'ConfigureChangeModal.byMaterialCodes': '物料号',
    'ConfigureChangeModal.bySparepName': '备件名称',
    'ConfigureChangeModal.bySpareCount': '数量',//被替换备件数量
    'ConfigureChangeModal.spareCount': '数量',//替换备件数量
    'ConfigureChangeModal.createTime': '变更维护日期',
    'ConfigureChangeModal.replaceType': '类型',
    'ConfigureChangeModal.oldNewStatus': '新旧状态',
    'ConfigureChangeModal.firstVin': '首台使用Vin',
    'ConfigureChangeModal.factoryChangeTime': '基地切换时间',
    'ConfigureChangeModal.after': '替换件(变更后)',
    'ConfigureChangeModal.sparepCodes': '备件编号',
    'ConfigureChangeModal.materialCodes': '物料号',
    'ConfigureChangeModal.sparepName': '备件名称',
    'ConfigureChangeModal.remark': '备注',
    'ConfigureChangeModal.attachmentPath': '附件',
    'ConfigureChangeModal.download': '下载附件',
    'ConfigureChangeModal.processingStrategy': '变更备注',

    //是否添加到购物车
    'ShoppingCart.isAddShoppingCart':'确定将该备件添加到购物车吗？',
    'ShoppingCart.Determine':'确定',
    'ShoppingCart.cancel':'取消',
    //断点信息
    'ConfigureBreakPointModal.title': '断点信息',
    'ConfigureBreakPointModal.num': '序号',
    'ConfigureBreakPointModal.receptionVin': '变更后首台VIN码',
    'ConfigureBreakPointModal.factoryCode': '工厂',
    'ConfigureBreakPointModal.breakTime': '切换点时间',
    'ConfigureBreakPointModal.factoryType': '区域',

    //购物车查询
    'shopping.demand': '查询',
    'shopping.reset': '重置',
    'shopping.spareNoInput': '备件编号',
    'shopping.MATNRInput': '东风零件号',
    'shopping.startTimeInput': '请选择起始时间',
    'shopping.DeadlineInput': '请选择截止时间',

    //购物车表格
    'shopping.derive': '导出',
    'shopping.batchDelete': '批量删除',
    'shopping.tableNo': '序号',
    'shopping.tableSpareNo': '备件编号',
    'shopping.tableMATNR': '东风零件号',
    'shopping.tableSpareName': '备件名称',
    'shopping.tableServiceStation': '服务站代码',
    'shopping.tableOrderTime': '订购时间',
    'shopping.addtableOrderTime': '添加时间',
    'shopping.tableAmount': '数量',
    'shopping.tableOperation': '操作',
    'shopping.tableDelete': '删除',
    'shopping.pushSpareParts': '推送备件',

    //备件所属车系查询
    'CarsSpareParts.spareNoInput':'备件编号',
    'CarsSpareParts.MATNRInput':'东风零件号',
    'CarsSpareParts.carseriesCode':'车系',
    'CarsSpareParts.demand':'查询',
    'CarsSpareParts.reset':'重置',

    //备件所属车系表格
    'CarsSpareParts.tableNo':'序号',
    'CarsSpareParts.tableSpareNo':'备件编号',
    'CarsSpareParts.tableMATNR':'东风零件号',
    'CarsSpareParts.tableSpareName':'备件名称',
    'CarsSpareParts.tableAMG':'车系',
    'CarsSpareParts.tableAnnual':'年款',
    'CarsSpareParts.tableConfiguration':'配置',
    'CarsSpareParts.tableEngineDisplacement':'发动机排量',
    'CarsSpareParts.tableTransmission':'变速器',
    'CarsSpareParts.tableColor':'内饰颜色',
    'CarsSpareParts.tableDriveMode':'驱动方式',
    'CarsSpareParts.tableVehicleMaterialNumber':'整车物料号',

    //备件变更查询
    'sparePartsChangeQuery.spareNoInput':'备件编号',
    'sparePartsChangeQuery.MATNRInput':'东风零件号',
    'sparePartsChangeQuery.demand':'查询',
    'sparePartsChangeQuery.reset':'重置',

    //备件变更查询表格
    'sparePartsChangeQuery.tableNameOfNotice':'通知书名称',
    'sparePartsChangeQuery.tableAudiName':'车系名称',
    'sparePartsChangeQuery.tableGroupNumber':'分组号',
    'sparePartsChangeQuery.tableChangeType':'变更类型',
    'sparePartsChangeQuery.tableChangeTime':'变更时间',
    'sparePartsChangeQuery.operate':'操作',
    'sparePartsChangeQuery.tableSubstitutedMaterialNumber':'被替换件号',
    'sparePartsChangeQuery.tableSubstitutedName':'被替换件名称',
    'sparePartsChangeQuery.tableNumber':'数量',
    'sparePartsChangeQuery.tableReplacementMaterialNumber':'替换件号',
    'sparePartsChangeQuery.tableSubstituteName':'替换件名称',

    //订单历史查询
    'orderHistory.ChineseName':'中文名称',
    'orderHistory.demand':'查询',
    'orderHistory.reset':'重置',

    //订单历史表格
    'orderHistory.tableNo':'序号',
    'orderHistory.tableOrderNumber':'订单号',
    'orderHistory.tableOrderTimes':'订单时间',
    'orderHistory.tableOperation':'操作',
    'orderHistory.tableResubmit':'再次提交',
    'orderHistory.tableSeeDetails':'查看详情',
    'orderHistory.tableSpareNo':'备件编号',
    'orderHistory.tableMATNR':'东风零件号',
    'orderHistory.tableSpareName':'备件名称',
    'orderHistory.tableSubmissionTime':'提交时间',
    'orderHistory.tableOrderTime':'订购时间',
    'orderHistory.tableNumber':'数量',
    'orderHistory.tableConfirm':'确认',
    'orderHistory.tableCancel':'取消',
    'orderHistory.tableSubmitAgain':'确定要再次提交吗?',
    'orderHistory.chineseName':'中文名称',
    'orderHistory.SubmitSuccessfully':'提交成功',

    //查询二轨件查询
    'ConfigureSpareModal.TwoTrackFittings': '二轨件',
    'ConfigureSpareModal.OneTrackFittings': '一轨件',
    'ConfigureSpareModal.MaterialCoding': '东风零件号',
    'ConfigureSpareModal.NameOfMaterial': '物料名称',
    'ConfigureSpareModal.Supplier': '供应商',
    'ConfigureSpareModal.SelectionOfCorrespondingRailComponents': '选择对应一轨件',

    //车系查询store
    'ConfigureQuery.PleaseEnterVINCodeFirst':'请先输入vin码',
    'ConfigureQuery.VinCodeDoesNotExist':'请用配置查询',
    'ConfigureQuery.PleaseEnterTheSearchCriteria':'请输入搜索条件',
    'ConfigureQuery.carseriesCode':'请选择车系',
    'ConfigureQuery.TwoTrackFittings':'二轨件',
    'ConfigureQuery.ThreeTrackFittings':'三轨件',
    'ConfigureQuery.FourTrackFittings':'四轨件',
    'ConfigureQuery.FiveTrackFittings':'五轨件',
    'ConfigureQuery.SixTrackFittings':'六轨件',
    'ConfigureQuery.SevenTrackFittings':'七轨件',
    'ConfigureQuery.EightTrackFittings':'八轨件',
    'ConfigureQuery.NineTrackFittings':'九轨件',
    'ConfigureQuery.Time':'时间',
    'ConfigureQuery.success':'推送成功！',
    'ConfigureQuery.warning':'推送失败！',
    'ConfigureQuery.PleaseCheckTheVinCodeInOverseasCarSeries':'该车型暂不支持vin码查询！',
    'ConfigureQuery.PleaseCheckTheVinCodeInTheDomesticCarSeries':'该车型暂不支持vin码查询！',
    'ConfigureQuery.noAuthor':'未授权该品牌！',

    //精品目录
    'Boutique.index': '精品目录'
}



// WEBPACK FOOTER //
// ./src/components/locales/zh-CN.message.js